<template>
  <main v-loading="pageLoading">
    <section class="order_info">
      <figure class="desc">
        <i class="icon-gou"></i>
        <p>
          <span>订单提交成功，请您尽快付款！ 订单号：<b>{{ travelOrderInfo.order_sn }}</b></span>
          <span>请在<strong>2小时内</strong>完成订单支付， 否则订单会自动取消。</span>
        </p>
      </figure>
      <div class="price">
        <p><span>应付金额：</span><b>{{ ConversionPrice(travelOrderInfo.order_price) }}</b></p>
        <strong :class="{ open: showTable }" @click="showTable = !showTable">订单详情</strong>
      </div>
      <el-table :data="[travelOrderInfo]" v-show="showTable">

        <el-table-column prop="spu_name" label="产品名称"></el-table-column>
        <el-table-column prop="sku_name" label="套餐名称"></el-table-column>
        <el-table-column align="center" prop="created_at" label="下单时间"></el-table-column>
        <el-table-column align="center" prop="sku_travel_date" label="出发日期"></el-table-column>
        <el-table-column align="center" prop="sku_quantity" label="购买数量" width="80"></el-table-column>
        <el-table-column align="center" label="单价"> <template slot-scope="scope">￥{{
          ConversionPrice(scope.row.sku_price)
            }}</template></el-table-column>
      </el-table>
    </section>
    <section class="pay">
      <h3>支付方式</h3>
      <label>
        <el-radio v-model="payType" :disabled="true" label="0">余额支付</el-radio>
        <el-radio v-model="payType" label="1">第三方支付</el-radio>
      </label>
      <ul class="user" v-show="payType === '0'">
        <li>
          <span>账户余额：</span><b>0.00元</b>
          <strong>余额不足，请先<router-link :to="{ path: './' }">充值</router-link></strong>
        </li>
        <li>
          <span>支付密码：</span>
          <el-input disabled="" type="password" size="small" v-model="test"></el-input>
          <strong>请先设置支付密码，<router-link :to="{ path: './' }">点击设置</router-link>跳至设置支付密码页面</strong>
        </li>
      </ul>
      <nav v-show="payType === '1'" class="otherPay">
        <a :class="{ on: payOption === 'zfb' }" @click="updatePayType('alipay')"><img src="@assets/img/zhifubao.png"
            alt=""></a>
        <!-- <a :class="{ on: payOption === 'wx' }" @click="payOption = 'wx'"><img src="@assets/img/weixinzhifu.png"  alt=""></a> -->
        <a :class="{ on: payOption === 'wx' }" @click="updatePayType('wechat')"><img src="@assets/img/weixinzhifu.png"
            alt=""></a>
      </nav>
      <div class="qrcode" v-loading="loading" :class="{ pay_success: payState }">
        <!-- <vue-qrcode
          :value="`${payOption === 'wx' ? 'https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=tour&order_sn=' + travelOrderInfo.order_sn : alipayUrl}`"
          :options="{ width: 200 }" /> -->
        <vue-qrcode :value="qrCodeVal" :options="{ width: 200 }" />
        <p>手机扫码进行支付</p>

      </div>
    </section>
  </main>
</template>

<script>
import $tour from '@api/tour';
import $pay from '@api/pay';
import VueQrcode from 'vue-qrcode'
export default {
  components: {
    VueQrcode
  },
  data() {
    return {
      order_sn: '',
      travelOrderInfo: {},//订单相关参数
      paymentType: 'wechat',//支付方式 wechat:微信支付 alipay:支付宝支付
      qrCodeVal: '',//支付 二维码
      pageLoading: true,
      info: [{}],
      showTable: false,
      payType: '1',
      payOption: 'wx',
      alipayUrl: null,
      payState: false,
      loading: false, // 支付方式loading
      test: ''
    }
  },
  created() {
    const { order_sn } = this.$route.query;
    if (!order_sn) {
      this.$router.push({ name: 'tour' });
      return;
    }
    this.order_sn = order_sn;
    this.qrCodeVal = 'https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=xorder&order_sn=' + order_sn; //初始化 微信支付二维码
    this.getDetail(order_sn); // 通过订单号 获取订单详情
    this.listenPayResult(order_sn);
  },
  methods: {
    // 将数字转为 正常显示的价格
    ConversionPrice(price) {
      return price ? (Number(price) / 100).toFixed(2) : 0;
    },
    // 切换支付方式
    async updatePayType(payType) {
      let _this = this;
      _this.paymentType = payType;

      if (payType == 'alipay') {
        this.loading = true;
        await $pay.getAliPayCode(_this.order_sn).then((res) => {
          _this.qrCodeVal = res.source_qr_code_url + '?test=' + res.trade_no;
          _this.loading = false;
        });
      } else {
        // 微信支付二维码
        this.qrCodeVal = 'https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=xorder&order_sn=' + _this.order_sn;
      }

    },
    // 通过订单号 获取订单详情
    async getDetail(order_sn) {
      let _this = this;
      await $tour.getOrderDetailByOrderSn(order_sn).then((res) => {
        console.warn('---res', res)
        if (res.status == 'success') {
          _this.pageLoading = false;
          _this.travelOrderInfo = res.data;
          console.warn(res.data);
        }
      })
    },
    // 监听支付结果
    async listenPayResult(order_sn) {
      if (this.$route.name !== 'tour_pay') { return; }
      let _this = this;

      await $tour.getOrderDetailByOrderSn(order_sn).then((res) => {
        if (res.status == 'success') {
          const { status } = res.data;
          console.log('status 支付状态', status);
          if (status == "P") {
            setTimeout(async () => {
              return await _this.listenPayResult(order_sn);
            }, 2000);
          } else {
            _this.$message.success('支付成功！');
            _this.payState = true;
            setTimeout(() => {
              _this.$router.push({ name: 'tour_order_list' });
            }, 3000);
          }

        }
      })
    }
  }
}
</script>

<style scoped src="./pay.css"></style>